import {createBarbaPage} from '../baseBarbaPage';
import React from 'react';
import Cache from '../../src/js/cache';
import AddToCartAjax from '../woo-product-page/add-to-cart-ajax';
import { Base64 } from 'js-base64';
import qs from 'query-string';

export default  createBarbaPage({
    namespace: 'design-center',
    onEnter: function() {
        // The new Container is ready and attached to the DOM.
        AddToCartAjax();
        designCenter_PageLoad(Cache.get('designCenterComponent'));

        // Save Selection info to the back button and tab
        $('a.design-center-product__back-button, .design-center-tab__container .design-center-tab:nth-child(-n + 2) a').click((ev) => {
            // Disable back button on first click
            if ($(ev.currentTarget).hasClass('design-center-product__back-button')) {
                $(ev.currentTarget).addClass('design-center-product__back-button--disabled');
            }

            const currentQuery = qs.parse(location.search);
            let { url: backUrl, query: backQuery  } = qs.parseUrl(ev.currentTarget.href);

            backQuery = backQuery || {};
            if (R.path(['selectedhandle'],currentQuery)) {
                backQuery.selectedhandle = currentQuery.selectedhandle;
            }

            if (R.path(['selectedjaw'],currentQuery)) {
                backQuery.selectedjaw = currentQuery.selectedjaw;
            }
            // Set the new link url, then propagate to barba pjax event.
            ev.currentTarget.href = `${backUrl}?${qs.stringify(backQuery)}`;
        });
    },
    onEnterCompleted: function() {
        // The Transition has just finished.
        $('.design-center-product-detail__gallery-item-anchor').on('mouseenter', galleryHover);
        // Hide modal when hover on background
        let modalMouseFlag = false;
        $('#gallery-modal').mouseover((ev) => {
            if (modalMouseFlag) {
                modalMouseFlag = false;
                return;
            }
            $('#gallery-modal').modal('hide');
            $('.design-center-product-detail__gallery-item-anchor--hover').removeClass('design-center-product-detail__gallery-item-anchor--hover');
        });
        $('#gallery-modal > .modal-dialog').mouseover((ev) => {
            modalMouseFlag = true;
        });
    },
    onLeave: function() {
        // A new Transition toward a new page has just started.
        $('.design-center-product-detail__gallery-item-anchor').off('mouseenter', galleryHover);
    },
    onLeaveCompleted: function() {
        // The Container has just been removed from the DOM.
    }
});

function designCenter_PageLoad(designCenterComponent) {
    const {q: searchDefaultVal } = qs.parse(location.search);
    $('.design-center-navbar__search-box').val(searchDefaultVal);
    $('.design-center-nav__search-box').val(searchDefaultVal);

    $('.design-center-product-list__item').click((ev) => {
        if (!$(ev.currentTarget).hasClass('design-center-product-list__item--active')) {
            $('.design-center-product-list__item').removeClass('design-center-product-list__item--active');
            $(ev.currentTarget).addClass('design-center-product-list__item--active');

            const productID = ev.currentTarget.getAttribute('data-item-id');
            const base64Data = $(ev.currentTarget).find('[type=hidden]').val();
            const decodedData = Base64.decode(base64Data);
            const productInfo = JSON.parse(decodedData);

            const type = productInfo.type === 'handle'? 'handle' : 'jaw';

            let queryMap = qs.parse(location.search);
            queryMap[`selected${type}`] = productID; // Set Product ID to the Url

            designCenterComponent.setProductData(productInfo);
            history.pushState(null, 'Endoplus Design Center', `?${qs.stringify(queryMap)}`);

            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    });

    // This only applies to the Detail Page
    $('.design-center-product-detail input[type=radio][name=variation_id]').change((ev) => {
        let queryMap = qs.parse(location.search);
        let { type } = queryMap;
        type = type === 'handle' ? 'handle': type === 'jaw-insert' ? 'jaw' : 'accessories';
        const skuNumber = ev.currentTarget.getAttribute('data-item-sku');
        const length = parseFloat(ev.currentTarget.getAttribute('data-item-length'));

        if (type === 'handle' || type === 'jaw') {
            queryMap[`selected${type}`] = ev.currentTarget.value;
            designCenterComponent.setOptions(type,{
                itemNo: skuNumber,
                length,
            });
        }
        queryMap[`productid`] = ev.currentTarget.value;
        history.replaceState(null , 'Endoplus Design Center', `?${qs.stringify(queryMap)}`);
    });

    $('.design-center-product-detail__gallery-item-anchor').click((ev) => {
        ev.preventDefault();
        // Prevent click event refresh during hover event
        if (!$('#gallery-modal').hasClass('show')) {
            const modalContent = $(ev.currentTarget.parentNode).find('.design-center-product-detail__gallery-item-content').html();
            $('.modal-body').html(modalContent);

            $('#gallery-modal').modal();
        }
    });

    $('#gallery-modal').on('hidden.bs.modal', (ev) => {
        $('.modal-body').empty();
    });

    $('.design-center-navbar__search-btn').on('click',(ev) => {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        searchSubmit(true);
    });
    $('.design-center-navbar__search-box').on('keypress', (ev) => {
        ev.stopImmediatePropagation();
        if (ev.keyCode === 13) {
            searchSubmit(true);
        }
    });

    $('.design-center-nav__search-btn').on('click',(ev) => {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        searchSubmit(false);
    });
    $('.design-center-nav__search-box').on('keypress', (ev) => {
        ev.stopImmediatePropagation();
        if (ev.keyCode === 13) {
            searchSubmit(false);
        }
    });
}

function searchSubmit(isNavbar){
    const searchVal = (isNavbar) ? $('.design-center-navbar__search-box').val() : $('.design-center-nav__search-box').val();
    let queryMap = qs.parse(location.search);
    queryMap['q'] = searchVal;
    queryMap.state = 'search';
    const url = `?${qs.stringify(queryMap)}`;
    Barba.Pjax.goTo(url);
}

function galleryHover(ev) {
    if (!$('#gallery-modal').hasClass('show')) {
        $(ev.currentTarget).addClass('design-center-product-detail__gallery-item-anchor--hover');
        const modalContent = $(ev.currentTarget.parentNode).find('.design-center-product-detail__gallery-item-content').html();
        $('.modal-body').html(modalContent);
        $('#gallery-modal').modal('show');
    }
}
